

define(['angular', 'squid/index', 'text!./template.html', 'components/xo-models/src/checkout/index', 'components/xo-models/src/bml/index', 'components/xo-beaver/dist/logger'], function (angular, squid, template) {

    return angular.module('xo-bml-popup.directive', ['squid', 'xomodel.checkout', 'xomodel.bml', 'beaver']).directive('xoBmlPopup', function () {

        return {
            template: template,
            controller: function controller($scope, $populate, $rootScope, $CheckoutSessionModel, $BMLModel, $logger) {
                $populate($scope, {
                    checkoutSession: $CheckoutSessionModel.instance($rootScope.token)
                }).then(function () {
                    if ($scope.checkoutSession.showDeclinePopup) {
                        if (!$rootScope.bml) {
                            $rootScope.bml = new $BMLModel();
                        }
                        if (!$scope.bml) {
                            $scope.bml = $rootScope.bml;
                        }

                        $scope.bml.preferenceCheck = false;
                        $scope.bml.showModal = true;
                        $scope.bml.showModalBackdrop = true;

                        if ($scope.bml.applicationStatus() || $scope.bml.contingency) {
                            $scope.bml.showModalBackdrop = true;
                        }
                    }
                });

                $scope.bmlSetPreferrence = function () {
                    if ($scope.bml.preferenceCheck) {
                        $scope.bml.action('preference', {
                            data: {
                                financial_instrument_id: $scope.bml.financial_instrument_id
                            },

                            success: function success() {
                                $logger.info('COMPLETEBMLAPPLY_PREFERRED');
                                $scope.checkoutSession.message = {
                                    type: 'success',
                                    msgKeys: ['memberReview.bmlPreferredConfirmation']
                                };
                            }
                        });
                    } else {
                        $scope.checkoutSession.message = {
                            type: 'success',
                            msgKeys: ['paymentMethod.paymentMethodUpdated']
                        };
                    }
                    $scope.bml.showModal = false;
                };

                $scope.bmlClickContinue = function ($event) {
                    $event.preventDefault();
                    $scope.bml.showModalBackdrop = false;
                    $scope.bml.showModal = false;
                };
            }
        };
    });
});


//////////////////
// WEBPACK FOOTER
// ./components/xo-credit-components/src/bml-display/xo-bml-popup/directive.js
// module id = ./components/xo-credit-components/src/bml-display/xo-bml-popup/directive.js
// module chunks = 1